import utils from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
const tableOption = function (that, type = false) {
  return {
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: type ? '350px' : '100%',
    // calcHeight: 100,
    menuWidth: 200,
    labelSuffix: ' ：',
    labelWidth: '100',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '955px',
    rowKey:"pointCode",
    emptyText: '暂无数据',
    column: [
      {
        label: '巡更点名称',
        prop: 'pointName',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        clearable: true,
        align: 'center',
        search: true,
        minRows: 4,
        maxlength: 50,
        span: 12
      },
      {
        label: '室内/室外',
        prop: 'location',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        span: 12
      },
      {
        label: '巡更点位置',
        prop: 'place',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        span: 12
      },
      {
        label: '巡更点检查内容',
        prop: 'content',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        align: 'center',
        span: 12,
        hide: type
      },
      // {
      //   label: '二维码',
      //   prop: 'qr',
      //   editDisabled: false,
      //   addDisplay: true,
      //   editDisplay: true,
      //   overHidden: true,
      //   align: 'center',
      //   span: 12,
      //   hide: type
      // },
      {
        label: '打卡方式',
        prop: 'punchType',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: true,
        type: 'select',
        dicData: [
          { label: 'GPS', value: 0 },
          { label: '二维码', value: 1 }
          // { label: 'NFC', value: 2 }
        ],
        overHidden: true,
        align: 'center',
        span: 12,
        formatter: function (row, value) {
          if (value == 0) {
            return 'GPS'
          } else if (value == 1) {
            return '二维码'
          }
          // else {
          //   return 'NFC'
          // }
        }
      },
      {
        label: '创建人',
        prop: 'creator',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        align: 'center',
        span: 12,
        hide: type,
        searchSlot: true
      },
      {
        label: '创建时间',
        prop: 'createTime',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        valueFormat: 'timestamp',
        span: 12,
        hide: type,
        align: 'center'
      }
    ]
  }
}
export default tableOption
